module.exports = __webpack_public_path__ + "static/media/Aditya_Gund.8854ea1a.png";